<template>
  <div :class="$style.section">
    <div :class="$style.sectionTitle">
      <p :class="headerClassName">
        MacOS Keychain Application Access
      </p>
    </div>
    <div>
      <p v-if="!showTrustedAppsSection">
        <Icon
          :class="$style.warningMessage"
          icon="info"
        />
        Global Certificate Distribution must be turned on to use this feature.
      </p>
      <p :class="mainTextClassName">
        When some SSO-enabled applications on macOS devices attempt to authenticate users
        via JumpCloud, they don’t open a browser window to do so.
        Instead, they present the website in-app, and the app can’t be added to the
        Device Trust certificate used to authenticate.
        MacOS Keychain Application Access lets you add these apps as trusted so that your users
        don’t encounter a keychain password prompt from their devices.
        <ExternalLink
          :href="$options.appAuthKbLink"
          text="Learn more."
        />
      </p>
    </div>

    <div v-if="showTrustedAppsSection">
      <AppAuthorizationItemTable />
    </div>
  </div>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import AppAuthorizationItemTable from 'client/Security/AppAuthorization/AppAuthorizationItemTable';
import ExternalLink from 'client/components/ExternalLink';
import KbArticleUrls from 'client/util/Constants/KbArticleUrls';

export default {
  name: 'AppAuthorizationSection',

  components: {
    ExternalLink,
    AppAuthorizationItemTable,
    Icon,
  },

  props: {
    deviceCertEnabled: {
      type: Boolean,
      default: false,
    },
  },

  computed: {

    headerClassName() {
      return this.deviceCertEnabled ? this.$style.header : this.$style.disabled;
    },

    mainTextClassName() {
      return this.deviceCertEnabled ? '' : this.$style.disabled;
    },

    showTrustedAppsSection() {
      return this.deviceCertEnabled;
    },
  },

  appAuthKbLink: KbArticleUrls.appAuthorizationConfiguration,
};
</script>

<style module>
.header {
  font-weight: 600;
}

.disabled {
  color: var(--jcGrey400);
}

.sectionTitle {
  align-items: center;
  display: flex;
  justify-content: normal;
  margin-top: 1rem;
}

.section {
  border-top: solid 1px var(--jcGrey300);
}

.warningMessage {
  color: var(--jc-color-informational-base);
  margin-right: 8px;
}
</style>
